"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

function useRendersCount(message) {
  var enableUseRendersCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var renders = (0, _react.useRef)(1);

  if (enableUseRendersCount === true || window.enableUseRendersCount === true) {
    console.log("".concat(message, " renders count: ").concat(renders.current++));
  }
}

var _default = useRendersCount;
exports["default"] = _default;